import React from 'react';
import {
  Form,
  Input,
  InputNumber,
  Card,
  Typography,
  Row,
  Col
} from 'antd';

const { Title } = Typography;
const { TextArea } = Input;

const parseHintTokens = (value?: string) =>
  (value ?? '')
    .split(/[,\n]/)
    .map((token) => token.trim())
    .filter(Boolean);

interface FreeWritingSectionProps {
  onKeywordChange?: (value: string) => void;
  onWritingCountChange?: (value: number | null) => void;
  onHintChange?: (value: string) => void;
  title?: string; // 유형별 타이틀
}

const FreeWritingSection: React.FC<FreeWritingSectionProps> = ({
  onKeywordChange,
  onWritingCountChange,
  onHintChange,
  title = '프리라이팅'
}) => {
  return (
    <Card className='pb-5 border-b border-gray-200'>
      <Title level={4} className='mb-4'>{title}</Title>
      
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            label="제시어"
            name="keyword"
          >
            <Input
              placeholder="제시어를 입력하세요"
              size="large"
              onChange={(e) => onKeywordChange?.(e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col span={4} >
          <Form.Item
            label="프리라이팅 갯수"
            name="writingCount"
            rules={[
              { required: true, message: '프리라이팅 갯수를 입력해주세요' },
              { type: 'number', min: 1, max: 10, message: '1~10개의 정수를 입력해주세요' }
            ]}
            extra="최소 1개, 최대 10개까지 지정할 수 있습니다."
          >
            <InputNumber
              placeholder="1~10"
              size="large"
              min={1}
              max={10}
              step={1}
              precision={0}
              style={{ width: '100%' }}
              onChange={(value) => onWritingCountChange?.(value)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Col span={8}>
          <Form.Item
            label="힌트"
            name="hint"
            dependencies={['writingCount']}
            rules={[
              { required: true, message: '힌트를 입력해주세요' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value) return Promise.resolve();
                  const hintTokens = parseHintTokens(value);
                  if (hintTokens.length === 0) {
                    return Promise.reject(new Error('힌트를 입력해주세요'));
                  }
                  const writingCount = Number(getFieldValue('writingCount'));
                  if (!Number.isFinite(writingCount)) {
                    return Promise.resolve();
                  }
                  if (hintTokens.length !== writingCount) {
                    return Promise.reject(
                      new Error(`힌트 개수는 프리라이팅 갯수(${writingCount})와 동일해야 합니다.`)
                    );
                  }
                  return Promise.resolve();
                }
              })
            ]}
          >
            <Input
              placeholder="힌트를 입력하세요 (쉼표로 구분)"
              size="large"
              onChange={(e) => onHintChange?.(e.target.value)}
            />
          </Form.Item>
        </Col>
    </Card>
  );
};

export default FreeWritingSection; 